import e, { Component as t } from "react";
import { Paginator as o } from "../Paginator/Paginator.js";
import r from "../../../../node_modules/classnames/index.js";
import n from "../../../utils/DomHandler.js";
import s from "../../../utils/ObjectUtils.js";
import l from "../../../utils/UniqueComponentId.js";
import { TableBody as i } from "./TableBody.js";
import { TableFooter as a } from "./TableFooter.js";
import { TableHeader as p } from "./TableHeader.js";
import { VirtualScroller as u } from "../VirtualScroller/VirtualScroller.js";
import { t as d } from "../../../i18/index.js";
function c(e, t) {
  (null == t || t > e.length) && (t = e.length);
  for (var o = 0, r = Array(t); o < t; o++) r[o] = e[o];
  return r;
}
function h(e) {
  if (void 0 === e) throw ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function m(e, t) {
  for (var o = 0; o < t.length; o++) {
    var r = t[o];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
  }
}
function f(e, t, o) {
  return t in e ? Object.defineProperty(e, t, {
    value: o,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = o, e;
}
function g(e) {
  return (g = Object.setPrototypeOf ? Object.getPrototypeOf : function (e) {
    return e.__proto__ || Object.getPrototypeOf(e);
  })(e);
}
function S(e) {
  for (var t = 1; t < arguments.length; t++) {
    var o = null != arguments[t] ? arguments[t] : {},
      r = Object.keys(o);
    "function" == typeof Object.getOwnPropertySymbols && (r = r.concat(Object.getOwnPropertySymbols(o).filter(function (e) {
      return Object.getOwnPropertyDescriptor(o, e).enumerable;
    }))), r.forEach(function (t) {
      f(e, t, o[t]);
    });
  }
  return e;
}
function b(e, t) {
  return (b = Object.setPrototypeOf || function (e, t) {
    return e.__proto__ = t, e;
  })(e, t);
}
function y(e) {
  return function (e) {
    if (Array.isArray(e)) return c(e);
  }(e) || function (e) {
    if ("undefined" != typeof Symbol && null != e[Symbol.iterator] || null != e["@@iterator"]) return Array.from(e);
  }(e) || function (e, t) {
    if (e) {
      if ("string" == typeof e) return c(e, t);
      var o = Object.prototype.toString.call(e).slice(8, -1);
      if ("Object" === o && e.constructor && (o = e.constructor.name), "Map" === o || "Set" === o) return Array.from(o);
      if ("Arguments" === o || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(o)) return c(e, t);
    }
  }(e) || function () {
    throw TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }();
}
var v = function (t) {
  !function (e, t) {
    if ("function" != typeof t && null !== t) throw TypeError("Super expression must either be null or a function");
    e.prototype = Object.create(t && t.prototype, {
      constructor: {
        value: e,
        writable: !0,
        configurable: !0
      }
    }), t && b(e, t);
  }(C, t);
  var d,
    c,
    v,
    w = (d = function () {
      if ("undefined" == typeof Reflect || !Reflect.construct || Reflect.construct.sham) return !1;
      if ("function" == typeof Proxy) return !0;
      try {
        return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
      } catch (e) {
        return !1;
      }
    }(), function () {
      var e,
        t,
        o = g(C);
      if (d) {
        var r = g(this).constructor;
        t = Reflect.construct(o, arguments, r);
      } else t = o.apply(this, arguments);
      return (e = t) && ("object" == (e && "undefined" != typeof Symbol && e.constructor === Symbol ? "symbol" : typeof e) || "function" == typeof e) ? e : h(this);
    });
  function C(e) {
    var t;
    return !function (e, t) {
      if (!(e instanceof t)) throw TypeError("Cannot call a class as a function");
    }(this, C), f(h(t = w.call(this, e)), "attributeSelector", void 0), f(h(t), "columnWidthsState", void 0), f(h(t), "tableWidthState", void 0), f(h(t), "table", void 0), f(h(t), "el", void 0), f(h(t), "styleElement", void 0), f(h(t), "resizeColumn", void 0), f(h(t), "resizeColumnElement", void 0), f(h(t), "columnResizing", void 0), f(h(t), "lastResizeHelperX", void 0), f(h(t), "documentColumnResizeEndListener", void 0), f(h(t), "documentColumnResizeListener", void 0), f(h(t), "colReorderIconWidth", void 0), f(h(t), "colReorderIconHeight", void 0), f(h(t), "draggedColumn", void 0), f(h(t), "draggedColumnElement", void 0), f(h(t), "dropPosition", void 0), f(h(t), "columnSortable", void 0), f(h(t), "columnSortFunction", void 0), f(h(t), "columnField", void 0), f(h(t), "reorderIndicatorUp", void 0), f(h(t), "reorderIndicatorDown", void 0), f(h(t), "resizeHelper", void 0), f(h(t), "responsiveStyleElement", void 0), f(h(t), "groupRowsSortMeta", void 0), f(h(t), "defaultSortOrder", void 0), f(h(t), "tableHeaderWrapperEl", void 0), f(h(t), "tableFooterWrapperEl", void 0), f(h(t), "state", {
      d_rows: t.props.rows,
      columnOrder: [],
      groupRowsSortMeta: null,
      editingMeta: {}
    }), f(h(t), "allRowsSelected", function (e) {
      var o = t.props.frozenValue ? y(t.props.frozenValue).concat(y(e)) : e,
        r = t.props.isRowSelectable ? o.filter(function (e) {
          return t.props.isRowSelectable(e);
        }) : o,
        n = t.props.lazy ? t.props.totalRecords : r ? r.length : 0;
      return r && n > 0 && t.props.selection && t.props.selection.length > 0 && t.props.selection.length === n;
    }), f(h(t), "onEditingMetaChange", function (e) {
      var o = e.rowData,
        r = e.field,
        n = e.rowIndex,
        s = e.editing,
        l = S({}, t.state.editingMeta),
        i = l[n];
      if (s) i || (i = l[n] = {
        data: S({}, o),
        fields: []
      }), i.fields.push(r);else if (i) {
        var a = i.fields.filter(function (e) {
          return e !== r;
        });
        a.length ? i.fields = a : delete l[n];
      }
      t.setState({
        editingMeta: l
      });
    }), f(h(t), "clearEditingMetaData", function () {
      t.props.editMode && s.isNotEmpty(t.state.editingMeta) && t.setState({
        editingMeta: {}
      });
    }), f(h(t), "onColumnResizeStart", function (e) {
      var o = e.originalEvent,
        r = e.column,
        s = n.getOffset(t.el).left;
      t.resizeColumn = r, t.resizeColumnElement = o.currentTarget.parentElement, t.columnResizing = !0, t.lastResizeHelperX = o.pageX - Number(s) + t.el.scrollLeft, t.bindColumnResizeEvents();
    }), f(h(t), "onColumnResize", function (e) {
      var o = Number(n.getOffset(t.el).left);
      n.addClass(t.el, "datatable--unselectable-text"), t.resizeHelper.style.height = t.el.offsetHeight + "px", t.resizeHelper.style.top = "0px", t.resizeHelper.style.left = e.pageX - o + t.el.scrollLeft + "px", t.resizeHelper.style.display = "block";
    }), f(h(t), "onColumnResizeEnd", function () {
      var e = t.resizeHelper.offsetLeft - t.lastResizeHelperX,
        o = t.resizeColumnElement.offsetWidth,
        r = o + e;
      if (o + e > parseInt(t.resizeColumnElement.style.minWidth || 15, 10)) {
        if ("fit" === t.props.columnResizeMode) {
          var s = t.resizeColumnElement.nextElementSibling.offsetWidth - e;
          r > 15 && s > 15 && t.resizeTableCells(r, s);
        } else if ("expand" === t.props.columnResizeMode) {
          var l = t.table.offsetWidth + e + "px";
          t.table.style.width = l, t.table.style.minWidth = l, t.resizeTableCells(r);
        }
        t.props.onColumnResizeEnd && t.props.onColumnResizeEnd({
          element: t.resizeColumnElement,
          column: t.resizeColumn,
          delta: e
        }), t.isStateful() && t.saveState();
      }
      t.resizeHelper.style.display = "none", t.resizeColumn = null, t.resizeColumnElement = null, n.removeClass(t.el, "datatable--unselectable-text"), t.unbindColumnResizeEvents();
    }), f(h(t), "onColumnHeaderMouseDown", function (e) {
      n.clearSelection();
      var o = e.originalEvent,
        r = e.column;
      t.props.reorderableColumns && !1 !== t.getColumnProp(r, "reorderable") && ("INPUT" === o.target.nodeName || "TEXTAREA" === o.target.nodeName || n.hasClass(o.target, "datatable__column-resizer") ? o.currentTarget.draggable = !1 : o.currentTarget.draggable = !0);
    }), f(h(t), "onColumnHeaderCheckboxChange", function (e, o) {
      var r,
        n = e.originalEvent;
      e.checked ? (r = [], t.props.onAllRowsUnselect && t.props.onAllRowsUnselect({
        originalEvent: n,
        data: r,
        type: "all"
      })) : (r = t.props.frozenValue ? y(t.props.frozenValue).concat(y(o)) : o, r = t.props.isRowSelectable ? r.filter(function (e) {
        return t.props.isRowSelectable(e);
      }) : r, t.props.onAllRowsSelect && t.props.onAllRowsSelect({
        originalEvent: n,
        data: r,
        type: "all"
      })), t.props.onSelectionChange && t.props.onSelectionChange({
        originalEvent: n,
        value: r
      });
    }), f(h(t), "onColumnHeaderDragStart", function (e) {
      var o = e.originalEvent,
        r = e.column;
      if (t.columnResizing) {
        o.preventDefault();
        return;
      }
      t.colReorderIconWidth = n.getHiddenElementOuterWidth(t.reorderIndicatorUp), t.colReorderIconHeight = n.getHiddenElementOuterHeight(t.reorderIndicatorUp), t.draggedColumn = r, t.draggedColumnElement = t.findParentHeader(o.currentTarget), o.dataTransfer.setData("text", "b");
    }), f(h(t), "onColumnHeaderDragOver", function (e) {
      var o = e.originalEvent,
        r = t.findParentHeader(o.currentTarget);
      if (t.props.reorderableColumns && t.draggedColumnElement && r && (o.preventDefault(), t.draggedColumnElement !== r)) {
        var s = n.getOffset(t.el),
          l = n.getOffset(r),
          i = Number(l.left) - Number(s.left),
          a = Number(l.left) + r.offsetWidth / 2;
        t.reorderIndicatorUp.style.top = Number(l.top) - Number(s.top) - (t.colReorderIconHeight - 1) + "px", t.reorderIndicatorDown.style.top = Number(l.top) - Number(s.top) + r.offsetHeight + "px", o.pageX > a ? (t.reorderIndicatorUp.style.left = i + r.offsetWidth - Math.ceil(t.colReorderIconWidth / 2) + "px", t.reorderIndicatorDown.style.left = i + r.offsetWidth - Math.ceil(t.colReorderIconWidth / 2) + "px", t.dropPosition = 1) : (t.reorderIndicatorUp.style.left = i - Math.ceil(t.colReorderIconWidth / 2) + "px", t.reorderIndicatorDown.style.left = i - Math.ceil(t.colReorderIconWidth / 2) + "px", t.dropPosition = -1), t.reorderIndicatorUp.style.display = "block", t.reorderIndicatorDown.style.display = "block";
      }
    }), f(h(t), "onColumnHeaderDragLeave", function (e) {
      var o = e.originalEvent;
      t.props.reorderableColumns && t.draggedColumnElement && (o.preventDefault(), t.reorderIndicatorUp.style.display = "none", t.reorderIndicatorDown.style.display = "none");
    }), f(h(t), "onColumnHeaderDrop", function (e) {
      var o = e.originalEvent,
        r = e.column;
      if (o.preventDefault(), t.draggedColumnElement) {
        var l = n.index(t.draggedColumnElement),
          i = n.index(t.findParentHeader(o.currentTarget)),
          a = l !== i;
        if (a && (i - l == 1 && -1 === t.dropPosition || l - i == 1 && 1 === t.dropPosition) && (a = !1), a) {
          var p = t.getColumns(),
            u = function u(e, t) {
              return e.props.columnKey || t.props.columnKey ? s.equals(e.props, t.props, "columnKey") : s.equals(e.props, t.props, "field");
            },
            d = p.findIndex(function (e) {
              return u(e, t.draggedColumn);
            }),
            c = p.findIndex(function (e) {
              return u(e, r);
            });
          c < d && 1 === t.dropPosition && c++, c > d && -1 === t.dropPosition && c--, s.reorderArray(p, d, c);
          var h = p.reduce(function (e, t) {
            return e.push(t.props.columnKey || t.props.field), e;
          }, []);
          t.setState({
            columnOrder: h
          }), t.props.onColReorder && t.props.onColReorder({
            originalEvent: o,
            dragIndex: d,
            dropIndex: c,
            columns: p
          });
        }
        t.reorderIndicatorUp.style.display = "none", t.reorderIndicatorDown.style.display = "none", t.draggedColumnElement.draggable = !1, t.draggedColumnElement = null, t.draggedColumn = null, t.dropPosition = null;
      }
    }), f(h(t), "onPageChange", function (e) {
      t.clearEditingMetaData(), t.props.onPage ? t.props.onPage(e) : t.setState({
        first: e.first,
        rows: e.rows
      }), t.props.onValueChange && t.props.onValueChange(t.processedData());
    }), f(h(t), "onSortChange", function (e) {
      t.clearEditingMetaData();
      var o,
        r,
        n = e.originalEvent,
        s = e.column,
        l = e.sortableDisabledFields,
        i = s.props.sortField || s.props.field,
        a = t.props.defaultSortOrder;
      if (t.columnSortable = s.props.sortable, t.columnSortFunction = s.props.sortFunction, t.columnField = s.props.sortField, "multiple" === t.props.sortMode) {
        var p = n.metaKey || n.ctrlKey,
          u = (o = y(t.getMultiSortMeta())).find(function (e) {
            return e.field === i;
          });
        a = u ? t.getCalculatedSortOrder(u.order) : a;
        var d = {
          field: i,
          order: a
        };
        a ? (o = p ? o : o.filter(function (e) {
          return l.some(function (t) {
            return t === e.field;
          });
        }), t.addSortMeta(d, o)) : t.props.removableSort && t.removeSortMeta(d, o), r = {
          multiSortMeta: o
        };
      } else a = t.getSortField() === i ? t.getCalculatedSortOrder(t.getSortOrder()) : a, t.props.removableSort && (i = a ? i : null), r = {
        sortField: i,
        sortOrder: a
      };
      t.props.onSort ? t.props.onSort(r) : (r.first = 0, t.setState(r)), t.props.onValueChange && t.props.onValueChange(t.processedData({
        sortField: i,
        sortOrder: a,
        multiSortMeta: o
      }));
    }), t.props.onPage || (t.state.first = e.first, t.state.rows = e.rows), t.props.onSort || (t.state.sortField = e.sortField, t.state.sortOrder = e.sortOrder, t.state.multiSortMeta = e.multiSortMeta), t.isStateful() && t.restoreState(t.state), t.attributeSelector = l(), t.getSpacerHeight = t.getSpacerHeight.bind(h(t)), t;
  }
  return c = [{
    key: "isCustomStateStorage",
    value: function value() {
      return "custom" === this.props.stateStorage;
    }
  }, {
    key: "isStateful",
    value: function value() {
      return null !== this.props.stateKey || this.isCustomStateStorage();
    }
  }, {
    key: "isVirtualScrollerDisabled",
    value: function value() {
      return s.isEmpty(this.props.virtualScrollerOptions) || !this.props.scrollable;
    }
  }, {
    key: "getFirst",
    value: function value() {
      return this.props.onPage ? this.props.first : this.state.first;
    }
  }, {
    key: "getRows",
    value: function value() {
      return this.props.onPage ? this.props.rows : this.state.rows;
    }
  }, {
    key: "getSortField",
    value: function value() {
      return this.props.onSort ? this.props.sortField : this.state.sortField;
    }
  }, {
    key: "getSortOrder",
    value: function value() {
      return this.props.onSort ? this.props.sortOrder : this.state.sortOrder;
    }
  }, {
    key: "getMultiSortMeta",
    value: function value() {
      return (this.props.onSort ? this.props.multiSortMeta : this.state.multiSortMeta) || [];
    }
  }, {
    key: "getColumnProp",
    value: function value(e, t) {
      return e.props[t];
    }
  }, {
    key: "getColumns",
    value: function value(t) {
      var o = this,
        r = e.Children.toArray(this.props.children);
      if (!r) return null;
      if (!t && this.props.reorderableColumns && this.state.columnOrder) {
        var n = this.state.columnOrder.reduce(function (e, t) {
          var n = o.findColumnByKey(r, t);
          return n && e.push(n), e;
        }, []);
        return y(n).concat(y(r.filter(function (e) {
          return 0 > n.indexOf(e);
        })));
      }
      return r;
    }
  }, {
    key: "getStorage",
    value: function value() {
      switch (this.props.stateStorage) {
        case "local":
          return window.localStorage;
        case "session":
          return window.sessionStorage;
        case "custom":
          return null;
        default:
          throw Error(this.props.stateStorage + " is not a valid value for the state storage, supported values are 'local', 'session' and 'custom'.");
      }
    }
  }, {
    key: "saveState",
    value: function value() {
      var e = {};
      this.props.paginator && (e.first = this.getFirst(), e.rows = this.getRows());
      var t = this.getSortField();
      t && (e.sortField = t, e.sortOrder = this.getSortOrder());
      var o = this.getMultiSortMeta();
      if (o && (e.multiSortMeta = o), this.props.resizableColumns && this.saveColumnWidths(e), this.props.reorderableColumns && (e.columnOrder = this.state.columnOrder), this.props.expandedRows && (e.expandedRows = this.props.expandedRows), this.props.selection && this.props.onSelectionChange && (e.selection = this.props.selection), this.isCustomStateStorage()) this.props.customSaveState && this.props.customSaveState(e);else {
        var r = this.getStorage();
        s.isNotEmpty(e) && r.setItem(this.props.stateKey, JSON.stringify(e));
      }
      this.props.onStateSave && this.props.onStateSave(e);
    }
  }, {
    key: "clearState",
    value: function value() {
      var e = this.getStorage();
      e && this.props.stateKey && e.removeItem(this.props.stateKey);
    }
  }, {
    key: "restoreState",
    value: function value(e) {
      var t = {};
      if (this.isCustomStateStorage()) this.props.customRestoreState && (t = this.props.customRestoreState());else {
        var o = this.getStorage().getItem(this.props.stateKey),
          r = /\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}.\d{3}Z/;
        o && (t = JSON.parse(o, function (e, t) {
          return "string" == typeof t && r.test(t) ? new Date(t) : t;
        }));
      }
      this._restoreState(t, e);
    }
  }, {
    key: "_restoreState",
    value: function value(e) {
      var t,
        o,
        r = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
      return s.isNotEmpty(e) && (this.props.paginator && (this.props.onPage ? this.props.onPage({
        first: t = e.first,
        rows: o = e.rows,
        page: Math.floor(t / o),
        pageCount: Math.ceil(this.getTotalRecords(this.processedData()) / o) || 1
      }) : (r.first = e.first, r.rows = e.rows)), e.sortField && (this.props.onSort ? this.props.onSort({
        sortField: e.sortField,
        sortOrder: e.sortOrder
      }) : (r.sortField = e.sortField, r.sortOrder = e.sortOrder)), e.multiSortMeta && (this.props.onSort ? this.props.onSort({
        multiSortMeta: e.multiSortMeta
      }) : r.multiSortMeta = e.multiSortMeta), this.props.resizableColumns && (this.columnWidthsState = e.columnWidths, this.tableWidthState = e.tableWidth), this.props.reorderableColumns && (r.columnOrder = e.columnOrder), e.expandedRows && this.props.onRowToggle && this.props.onRowToggle({
        data: e.expandedRows
      }), e.selection && this.props.onSelectionChange && this.props.onSelectionChange({
        value: e.selection
      }), this.props.onStateRestore && this.props.onStateRestore(e)), r;
    }
  }, {
    key: "saveColumnWidths",
    value: function value(e) {
      var t = [];
      n.find(this.el, ".datatable__head > tr > th").forEach(function (e) {
        return t.push(n.getOuterWidth(e));
      }), e.columnWidths = t.join(","), "expand" === this.props.columnResizeMode && (e.tableWidth = n.getOuterWidth(this.table) + "px");
    }
  }, {
    key: "restoreColumnWidths",
    value: function value() {
      var e = this;
      if (this.columnWidthsState) {
        var t = this.columnWidthsState.split(",");
        if ("expand" === this.props.columnResizeMode && this.tableWidthState && (this.table.style.width = this.tableWidthState, this.table.style.minWidth = this.tableWidthState, this.el.style.width = this.tableWidthState), this.createStyleElement(), this.props.scrollable && t && t.length > 0) {
          var o = "";
          t.forEach(function (t, r) {
            o += "\n                        .kaseya-ui-datatable[".concat(e.attributeSelector, "] .datatable__head > tr > th:nth-child(").concat(r + 1, ") {\n                            flex: 0 0 ").concat(t, "px;\n                        }\n\n                        .kaseya-ui-datatable[").concat(e.attributeSelector, "] .datatable__body > tr > td:nth-child(").concat(r + 1, ") {\n                            flex: 0 0 ").concat(t, "px;\n                        }\n                    ");
          }), this.styleElement.innerHTML = o;
        } else n.find(this.table, ".datatable__head > tr > th").forEach(function (e, o) {
          return e.style.width = t[o] + "px";
        });
      }
    }
  }, {
    key: "findParentHeader",
    value: function value(e) {
      if ("TH" === e.nodeName) return e;
      for (var t = e.parentElement; "TH" !== t.nodeName && (t = t.parentElement););
      return t;
    }
  }, {
    key: "getGroupRowSortField",
    value: function value() {
      return "single" === this.props.sortMode ? this.props.sortField : this.state.groupRowsSortMeta ? this.state.groupRowsSortMeta.field : null;
    }
  }, {
    key: "getSelectionModeInColumn",
    value: function value(e) {
      if (e) {
        var t = e.find(function (e) {
          return !!e.props.selectionMode;
        });
        return t ? t.props.selectionMode : null;
      }
      return null;
    }
  }, {
    key: "hasRowReorderColumn",
    value: function value(e) {
      return !!e && !!e.find(function (e) {
        return !!e.props.rowReorder;
      });
    }
  }, {
    key: "findColumnByKey",
    value: function value(e, t) {
      return s.isNotEmpty(e) ? e.find(function (e) {
        return e.props.columnKey === t || e.props.field === t;
      }) : null;
    }
  }, {
    key: "getTotalRecords",
    value: function value(e) {
      return this.props.lazy ? this.props.totalRecords : e ? e.length : 0;
    }
  }, {
    key: "resizeTableCells",
    value: function value(e, t) {
      var o = this,
        r = [],
        s = n.index(this.resizeColumnElement);
      n.find(this.table, ".datatable__head > tr > th").forEach(function (e) {
        return r.push(n.getOuterWidth(e));
      }), this.destroyStyleElement(), this.createStyleElement();
      var l = "";
      r.forEach(function (r, n) {
        var i = n === s ? e : t && n === s + 1 ? t : r,
          a = o.props.scrollable ? "flex: 0 0 ".concat(i, "px !important") : "width: ".concat(i, "px !important");
        l += "\n                .kaseya-ui-datatable[".concat(o.attributeSelector, "] .datatable__head > tr > th:nth-child(").concat(n + 1, "),\n                .kaseya-ui-datatable[").concat(o.attributeSelector, "] .datatable__body > tr > td:nth-child(").concat(n + 1, "),\n                .kaseya-ui-datatable[").concat(o.attributeSelector, "] .datatable__foot > tr > td:nth-child(").concat(n + 1, ") {\n                    ").concat(a, "\n                }\n            ");
      }), this.styleElement.innerHTML = l;
    }
  }, {
    key: "bindColumnResizeEvents",
    value: function value() {
      var e = this;
      this.documentColumnResizeListener || (this.documentColumnResizeListener = document.addEventListener("mousemove", function (t) {
        e.columnResizing && e.onColumnResize(t);
      })), this.documentColumnResizeEndListener || (this.documentColumnResizeEndListener = document.addEventListener("mouseup", function () {
        e.columnResizing && (e.columnResizing = !1, e.onColumnResizeEnd());
      }));
    }
  }, {
    key: "unbindColumnResizeEvents",
    value: function value() {
      this.documentColumnResizeListener && (document.removeEventListener("document", this.documentColumnResizeListener), this.documentColumnResizeListener = null), this.documentColumnResizeEndListener && (document.removeEventListener("document", this.documentColumnResizeEndListener), this.documentColumnResizeEndListener = null);
    }
  }, {
    key: "createStyleElement",
    value: function value() {
      this.styleElement = n.createInlineStyle();
    }
  }, {
    key: "createResponsiveStyle",
    value: function value() {
      if (!this.responsiveStyleElement) {
        this.responsiveStyleElement = n.createInlineStyle();
        var e = "\n@media screen and (max-width: ".concat(this.props.breakpoint, ") {\n    .kaseya-ui-datatable[").concat(this.attributeSelector, "] .datatable__head > tr > th,\n    .kaseya-ui-datatable[").concat(this.attributeSelector, "] .datatable__foot > tr > td {\n        display: none !important;\n    }\n\n    .kaseya-ui-datatable[").concat(this.attributeSelector, "] .datatable__body > tr > td {\n        display: flex;\n        width: 100% !important;\n        align-items: center;\n        justify-content: space-between;\n    }\n\n    .kaseya-ui-datatable[").concat(this.attributeSelector, "] .datatable__body > tr > td:not(:last-child) {\n        border: 0 none;\n    }\n\n    .kaseya-ui-datatable[").concat(this.attributeSelector, "].datatable--has-gridlines .datatable__body > tr > td:last-child {\n        border-top: 0;\n        border-right: 0;\n        border-left: 0;\n    }\n\n    .kaseya-ui-datatable[").concat(this.attributeSelector, "] .datatable__body > tr > td > .datatable__column-title {\n        display: block;\n    }\n}\n");
        this.responsiveStyleElement.innerHTML = e;
      }
    }
  }, {
    key: "destroyResponsiveStyle",
    value: function value() {
      this.responsiveStyleElement && (document.head.removeChild(this.responsiveStyleElement), this.responsiveStyleElement = null);
    }
  }, {
    key: "destroyStyleElement",
    value: function value() {
      this.styleElement && (document.head.removeChild(this.styleElement), this.styleElement = null);
    }
  }, {
    key: "getCalculatedSortOrder",
    value: function value(e) {
      return this.props.removableSort ? this.props.defaultSortOrder === e ? -1 * e : 0 : -1 * e;
    }
  }, {
    key: "addSortMeta",
    value: function value(e, t) {
      var o = t.findIndex(function (t) {
        return t.field === e.field;
      });
      o >= 0 ? t[o] = e : t.push(e);
    }
  }, {
    key: "removeSortMeta",
    value: function value(e, t) {
      var o = t.findIndex(function (t) {
        return t.field === e.field;
      });
      o >= 0 && t.splice(o, 1), t = t.length > 0 ? t : null;
    }
  }, {
    key: "sortSingle",
    value: function value(e, t, o) {
      if (this.props.groupRowsBy && this.props.groupRowsBy === this.props.sortField) {
        var r = [{
          field: this.props.sortField,
          order: this.props.sortOrder || this.props.defaultSortOrder
        }];
        return this.props.sortField !== t && r.push({
          field: t,
          order: o
        }), this.sortMultiple(e, r);
      }
      var n = y(e);
      return this.columnSortable && this.columnSortFunction ? n = this.columnSortFunction({
        field: t,
        order: o
      }) : n.sort(function (e, r) {
        var n = s.resolveFieldData(e, t),
          l = s.resolveFieldData(r, t);
        return o * (null === n && null !== l ? -1 : null !== n && null === l ? 1 : null === n && null === l ? 0 : "string" == typeof n && "string" == typeof l ? n.localeCompare(l, void 0, {
          numeric: !0
        }) : n < l ? -1 : n > l ? 1 : 0);
      }), n;
    }
  }, {
    key: "sortMultiple",
    value: function value(e) {
      var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : [],
        o = this;
      if (this.props.groupRowsBy && (this.groupRowsSortMeta || t.length && this.props.groupRowsBy === t[0].field)) {
        var r = t[0];
        this.groupRowsSortMeta || (this.groupRowsSortMeta = r), r.field !== this.groupRowsSortMeta.field && (t = [this.groupRowsSortMeta].concat(y(t)));
      }
      var n = y(e);
      if (this.columnSortable && this.columnSortFunction) {
        var s = t.find(function (e) {
            return e.field === o.columnField;
          }),
          l = this.columnField,
          i = s ? s.order : this.defaultSortOrder;
        n = this.columnSortFunction({
          field: l,
          order: i
        });
      } else n.sort(function (e, r) {
        return o.multisortField(e, r, t, 0);
      });
      return n;
    }
  }, {
    key: "multisortField",
    value: function value(e, t, o, r) {
      var n = s.resolveFieldData(e, o[r].field),
        l = s.resolveFieldData(t, o[r].field),
        i = null;
      if ("string" == typeof n || n instanceof String) {
        if (n.localeCompare && n !== l) return o[r].order * n.localeCompare(l, void 0, {
          numeric: !0
        });
      } else i = n < l ? -1 : 1;
      return n === l ? o.length - 1 > r ? this.multisortField(e, t, o, r + 1) : 0 : o[r].order * i;
    }
  }, {
    key: "reset",
    value: function value() {
      var e = {
        d_rows: this.props.rows,
        groupRowsSortMeta: null,
        editingMeta: {}
      };
      this.props.onPage || (this.state.first = this.props.first, this.state.rows = this.props.rows), this.props.onSort || (this.state.sortField = this.props.sortField, this.state.sortOrder = this.props.sortOrder, this.state.multiSortMeta = this.props.multiSortMeta), this.resetColumnOrder(), this.setState(e);
    }
  }, {
    key: "resetColumnOrder",
    value: function value() {
      var e = this.getColumns(!0),
        t = [];
      e && (t = e.reduce(function (e, t) {
        return e.push(t.props.columnKey || t.props.field), e;
      }, [])), this.setState({
        columnOrder: t
      });
    }
  }, {
    key: "exportCSV",
    value: function value(e) {
      var t,
        o = this,
        r = "\uFEFF",
        l = this.getColumns();
      t = e && e.selectionOnly ? this.props.selection || [] : y(this.props.frozenValue || []).concat(y(this.processedData() || [])), l.forEach(function (e, t) {
        var n = e.props,
          s = n.field,
          i = n.header;
        n.exportable && s && (r += "'" + (i || s) + "'", t < l.length - 1 && (r += o.props.csvSeparator));
      }), t.forEach(function (e) {
        r += "\n", l.forEach(function (t, n) {
          var i = t.props,
            a = i.field;
          if (i.exportable && a) {
            var p = s.resolveFieldData(e, a);
            p = null !== p ? o.props.exportFunction ? o.props.exportFunction({
              data: p,
              field: a,
              rowData: e,
              column: t
            }) : String(p).replace(/"/g, "''") : "", r += "'" + p + "'", n < l.length - 1 && (r += o.props.csvSeparator);
          }
        });
      }), n.exportCSV(r, this.props.exportFilename);
    }
  }, {
    key: "closeEditingCell",
    value: function value() {
      "row" !== this.props.editMode && document.body.click();
    }
  }, {
    key: "processedData",
    value: function value(e) {
      var t = this.props.value || [];
      if (!this.props.lazy && t && t.length) {
        var o = e && e.sortField || this.getSortField(),
          r = e && e.sortOrder || this.getSortOrder(),
          n = e && e.multiSortMeta || this.getMultiSortMeta();
        (o || s.isNotEmpty(n)) && ("single" === this.props.sortMode ? t = this.sortSingle(t, o, r) : "multiple" === this.props.sortMode && (t = this.sortMultiple(t, n)));
      }
      return t;
    }
  }, {
    key: "dataToRender",
    value: function value(e) {
      if (e && this.props.paginator) {
        var t = this.props.lazy ? 0 : this.getFirst();
        return e.slice(t, t + this.getRows());
      }
      return e;
    }
  }, {
    key: "componentDidMount",
    value: function value() {
      this.el.setAttribute(this.attributeSelector, ""), "stack" !== this.props.responsiveLayout || this.props.scrollable || this.createResponsiveStyle(), this.isStateful() && this.props.resizableColumns && this.restoreColumnWidths();
    }
  }, {
    key: "componentDidUpdate",
    value: function value(e) {
      this.isStateful() && this.saveState(), e.responsiveLayout === this.props.responsiveLayout || (this.destroyResponsiveStyle(), "stack" !== this.props.responsiveLayout || this.props.scrollable || this.createResponsiveStyle());
    }
  }, {
    key: "componentWillUnmount",
    value: function value() {
      this.unbindColumnResizeEvents(), this.destroyStyleElement(), this.destroyResponsiveStyle();
    }
  }, {
    key: "renderHeader",
    value: function value() {
      if (this.props.header) {
        var t = s.getJSXElement(this.props.header, {
          props: this.props
        });
        return e.createElement("div", {
          className: "datatable__header"
        }, t);
      }
      return null;
    }
  }, {
    key: "renderTableHeader",
    value: function value(t, o) {
      var r = this,
        n = this.getSortField(),
        s = this.getSortOrder(),
        l = y(this.getMultiSortMeta()),
        i = this.getGroupRowSortField(),
        a = this.attributeSelector,
        u = t.items,
        d = t.columns;
      return e.createElement(p, {
        wrapperRef: function wrapperRef(e) {
          return r.tableHeaderWrapperEl = e;
        },
        value: u,
        tableProps: this.props,
        tableSelector: a,
        columns: d,
        tabIndex: this.props.tabIndex,
        empty: o,
        headerColumnGroup: this.props.headerColumnGroup,
        resizableColumns: this.props.resizableColumns,
        onColumnResizeStart: this.onColumnResizeStart,
        onColumnResizerClick: this.props.onColumnResizerClick,
        onColumnResizerDoubleClick: this.props.onColumnResizerDoubleClick,
        sortMode: this.props.sortMode,
        sortField: n,
        sortOrder: s,
        multiSortMeta: l,
        groupRowsBy: this.props.groupRowsBy,
        groupRowSortField: i,
        onSortChange: this.onSortChange,
        allRowsSelected: this.allRowsSelected,
        onColumnCheckboxChange: this.onColumnHeaderCheckboxChange,
        onColumnMouseDown: this.onColumnHeaderMouseDown,
        onColumnDragStart: this.onColumnHeaderDragStart,
        onColumnDragOver: this.onColumnHeaderDragOver,
        onColumnDragLeave: this.onColumnHeaderDragLeave,
        onColumnDrop: this.onColumnHeaderDrop,
        reorderableColumns: this.props.reorderableColumns
      });
    }
  }, {
    key: "renderTableBody",
    value: function value(t, o, r, n) {
      var s = this.attributeSelector,
        l = this.getFirst(),
        a = this.state.editingMeta,
        p = t.rows,
        u = t.columns,
        d = t.contentRef,
        c = t.className,
        h = this.props.frozenValue && e.createElement(i, {
          value: this.props.frozenValue,
          className: "datatable__body--frozen",
          frozenRow: !0,
          tableProps: this.props,
          tableSelector: s,
          columns: u,
          selectionModeInColumn: o,
          first: l,
          editingMeta: a,
          onEditingMetaChange: this.onEditingMetaChange,
          tabIndex: this.props.tabIndex,
          onRowClick: this.props.onRowClick,
          onRowDoubleClick: this.props.onRowDoubleClick,
          onCellClick: this.props.onCellClick,
          selection: this.props.selection,
          onSelectionChange: this.props.onSelectionChange,
          lazy: this.props.lazy,
          paginator: this.props.paginator,
          onCellSelect: this.props.onCellSelect,
          onCellUnselect: this.props.onCellUnselect,
          onRowSelect: this.props.onRowSelect,
          onRowUnselect: this.props.onRowUnselect,
          dragSelection: this.props.dragSelection,
          onContextMenu: this.props.onContextMenu,
          onContextMenuSelectionChange: this.props.onContextMenuSelectionChange,
          metaKeySelection: this.props.metaKeySelection,
          selectionMode: this.props.selectionMode,
          cellSelection: this.props.cellSelection,
          contextMenuSelection: this.props.contextMenuSelection,
          dataKey: this.props.dataKey,
          expandedRows: this.props.expandedRows,
          onRowCollapse: this.props.onRowCollapse,
          onRowExpand: this.props.onRowExpand,
          onRowToggle: this.props.onRowToggle,
          editMode: this.props.editMode,
          editingRows: this.props.editingRows,
          onRowReorder: this.props.onRowReorder,
          scrollable: this.props.scrollable,
          rowGroupMode: this.props.rowGroupMode,
          groupRowsBy: this.props.groupRowsBy,
          expandableRowGroups: this.props.expandableRowGroups,
          loading: this.props.loading,
          emptyMessage: this.props.emptyMessage,
          rowGroupHeaderTemplate: this.props.rowGroupHeaderTemplate,
          rowExpansionTemplate: this.props.rowExpansionTemplate,
          rowGroupFooterTemplate: this.props.rowGroupFooterTemplate,
          onRowEditChange: this.props.onRowEditChange,
          compareSelectionBy: this.props.compareSelectionBy,
          selectOnEdit: this.props.selectOnEdit,
          onRowEditInit: this.props.onRowEditInit,
          rowEditValidator: this.props.rowEditValidator,
          onRowEditSave: this.props.onRowEditSave,
          onRowEditComplete: this.props.onRowEditComplete,
          onRowEditCancel: this.props.onRowEditCancel,
          cellClassName: this.props.cellClassName,
          responsiveLayout: this.props.responsiveLayout,
          showRowReorderElement: this.props.showRowReorderElement,
          expandedRowIcon: this.props.expandedRowIcon,
          collapsedRowIcon: this.props.collapsedRowIcon,
          rowClassName: this.props.rowClassName,
          infiniteScrollOptions: this.props.infiniteScrollOptions,
          isRowSelectable: this.props.isRowSelectable,
          isRowDisabled: this.props.isRowDisabled
        }),
        m = e.createElement(i, {
          value: this.dataToRender(p),
          className: c,
          empty: r,
          frozenRow: !1,
          tableProps: this.props,
          tableSelector: s,
          columns: u,
          selectionModeInColumn: o,
          first: l,
          editingMeta: a,
          onEditingMetaChange: this.onEditingMetaChange,
          tabIndex: this.props.tabIndex,
          onRowClick: this.props.onRowClick,
          onRowDoubleClick: this.props.onRowDoubleClick,
          onCellClick: this.props.onCellClick,
          selection: this.props.selection,
          onSelectionChange: this.props.onSelectionChange,
          lazy: this.props.lazy,
          paginator: this.props.paginator,
          onCellSelect: this.props.onCellSelect,
          onCellUnselect: this.props.onCellUnselect,
          onRowSelect: this.props.onRowSelect,
          onRowUnselect: this.props.onRowUnselect,
          dragSelection: this.props.dragSelection,
          onContextMenu: this.props.onContextMenu,
          onContextMenuSelectionChange: this.props.onContextMenuSelectionChange,
          metaKeySelection: this.props.metaKeySelection,
          selectionMode: this.props.selectionMode,
          cellSelection: this.props.cellSelection,
          contextMenuSelection: this.props.contextMenuSelection,
          dataKey: this.props.dataKey,
          expandedRows: this.props.expandedRows,
          onRowCollapse: this.props.onRowCollapse,
          onRowExpand: this.props.onRowExpand,
          onRowToggle: this.props.onRowToggle,
          editMode: this.props.editMode,
          editingRows: this.props.editingRows,
          onRowReorder: this.props.onRowReorder,
          scrollable: this.props.scrollable,
          rowGroupMode: this.props.rowGroupMode,
          groupRowsBy: this.props.groupRowsBy,
          expandableRowGroups: this.props.expandableRowGroups,
          loading: this.props.loading,
          emptyMessage: this.props.emptyMessage,
          rowGroupHeaderTemplate: this.props.rowGroupHeaderTemplate,
          rowExpansionTemplate: this.props.rowExpansionTemplate,
          rowGroupFooterTemplate: this.props.rowGroupFooterTemplate,
          onRowEditChange: this.props.onRowEditChange,
          compareSelectionBy: this.props.compareSelectionBy,
          selectOnEdit: this.props.selectOnEdit,
          onRowEditInit: this.props.onRowEditInit,
          rowEditValidator: this.props.rowEditValidator,
          onRowEditSave: this.props.onRowEditSave,
          onRowEditComplete: this.props.onRowEditComplete,
          onRowEditCancel: this.props.onRowEditCancel,
          cellClassName: this.props.cellClassName,
          responsiveLayout: this.props.responsiveLayout,
          showRowReorderElement: this.props.showRowReorderElement,
          expandedRowIcon: this.props.expandedRowIcon,
          collapsedRowIcon: this.props.collapsedRowIcon,
          rowClassName: this.props.rowClassName,
          infiniteScrollOptions: this.props.infiniteScrollOptions,
          virtualScrollerContentRef: d,
          virtualScrollerOptions: t,
          isVirtualScrollerDisabled: n,
          isRowSelectable: this.props.isRowSelectable,
          isRowDisabled: this.props.isRowDisabled
        });
      return e.createElement(e.Fragment, null, h, m);
    }
  }, {
    key: "renderTableFooter",
    value: function value(t) {
      var o = this,
        r = t.columns;
      return e.createElement(a, {
        wrapperRef: function wrapperRef(e) {
          return o.tableFooterWrapperEl = e;
        },
        tableProps: this.props,
        columns: r,
        footerColumnGroup: this.props.footerColumnGroup
      });
    }
  }, {
    key: "renderContent",
    value: function value(t, o, r, n) {
      var s,
        l,
        i = this;
      if (o) {
        var a = this.isVirtualScrollerDisabled(),
          p = this.props.virtualScrollerOptions || {};
        return e.createElement("div", {
          className: "datatable__wrapper",
          style: {
            maxHeight: a ? this.props.scrollHeight : ""
          }
        }, e.createElement(u, (s = S({}, p), l = l = {
          items: t,
          columns: o,
          style: {
            height: this.props.scrollHeight
          },
          disabled: a,
          loaderDisabled: !0,
          showSpacer: !1,
          getSpacerHeight: this.getSpacerHeight,
          contentTemplate: function contentTemplate(t) {
            var o = i.renderTableHeader(t, n),
              s = i.renderTableBody(t, r, n, a),
              l = i.renderTableFooter(t);
            return e.createElement("table", {
              ref: function ref(e) {
                i.table = e, t.spacerRef && t.spacerRef(e);
              },
              style: i.props.tableStyle,
              className: i.props.tableClassName,
              role: "table"
            }, o, s, l);
          }
        }, Object.getOwnPropertyDescriptors ? Object.defineProperties(s, Object.getOwnPropertyDescriptors(l)) : function (e, t) {
          var o = Object.keys(e);
          if (Object.getOwnPropertySymbols) {
            var r = Object.getOwnPropertySymbols(e);
            o.push.apply(o, r);
          }
          return o;
        }(Object(l)).forEach(function (e) {
          Object.defineProperty(s, e, Object.getOwnPropertyDescriptor(l, e));
        }), s)));
      }
    }
  }, {
    key: "renderFooter",
    value: function value() {
      if (this.props.footer) {
        var t = s.getJSXElement(this.props.footer, {
          props: this.props
        });
        return e.createElement("div", {
          className: "datatable__footer"
        }, t);
      }
      return null;
    }
  }, {
    key: "renderPaginator",
    value: function value(t, n) {
      var s = r("p-paginator-" + t, this.props.paginatorClassName);
      return e.createElement(o, {
        first: this.getFirst(),
        rows: this.getRows(),
        pageLinkSize: this.props.pageLinkSize,
        className: s,
        onPageChange: this.onPageChange,
        totalRecords: n,
        template: "Regular",
        rowsPerPageOptions: this.props.rowsPerPageOptions,
        CurrentPageReportTemplate: this.props.currentPageReportTemplate,
        leftContent: this.props.paginatorLeft,
        rightContent: this.props.paginatorRight,
        alwaysShow: this.props.alwaysShowPaginator,
        dropdownAppendTo: this.props.paginatorDropdownAppendTo
      });
    }
  }, {
    key: "renderPaginatorTop",
    value: function value(e) {
      return this.props.paginator && "bottom" !== this.props.paginatorPosition ? this.renderPaginator("top", e) : null;
    }
  }, {
    key: "renderPaginatorBottom",
    value: function value(e) {
      return this.props.paginator && "top" !== this.props.paginatorPosition ? this.renderPaginator("bottom", e) : null;
    }
  }, {
    key: "renderResizeHelper",
    value: function value() {
      var t = this;
      return this.props.resizableColumns ? e.createElement("div", {
        ref: function ref(e) {
          return t.resizeHelper = e;
        },
        className: "datatable__column-resizer-helper",
        style: {
          display: "none"
        }
      }) : null;
    }
  }, {
    key: "renderReorderIndicators",
    value: function value() {
      var t = this;
      if (this.props.reorderableColumns) {
        var o = {
          position: "absolute",
          display: "none"
        };
        return e.createElement(e.Fragment, null, e.createElement("span", {
          ref: function ref(e) {
            return t.reorderIndicatorUp = e;
          },
          className: "pi pi-arrow-down datatable__reorder-indicator-up",
          style: o
        }), e.createElement("span", {
          ref: function ref(e) {
            return t.reorderIndicatorDown = e;
          },
          className: "pi pi-arrow-up datatable__reorder-indicator-down",
          style: o
        }));
      }
      return null;
    }
  }, {
    key: "getSpacerHeight",
    value: function value(e) {
      var t = 0,
        o = 0;
      return this.tableHeaderWrapperEl && (t = this.tableHeaderWrapperEl.clientHeight), this.tableFooterWrapperEl && (o = this.tableFooterWrapperEl.clientHeight), e + t + o;
    }
  }, {
    key: "render",
    value: function value() {
      var t = this,
        o = this.processedData(),
        n = this.getColumns(),
        l = this.getTotalRecords(o),
        i = s.isEmpty(o),
        a = this.getSelectionModeInColumn(n),
        p = this.hasRowReorderColumn(n),
        u = r("kaseya-ui-datatable", {
          "datatable--has-hoverable-rows": this.props.rowHover || this.props.selectionMode || a || p || this.props.editMode,
          "datatable--has-multiple-selection": "multiple" === a,
          "datatable--has-single-selection": "single" === a,
          "datatable--has-bulk-items": this.props.bulkActionsDropdownProps,
          "datatable--auto-layout": this.props.autoLayout,
          "datatable--resizable": this.props.resizableColumns,
          "datatable--resizable-fit": this.props.resizableColumns && "fit" === this.props.columnResizeMode,
          "datatable--scrollable": this.props.scrollable,
          "datatable--scrollable-vertical": this.props.scrollable && "vertical" === this.props.scrollDirection,
          "datatable--scrollable-horizontal": this.props.scrollable && "horizontal" === this.props.scrollDirection,
          "datatable--scrollable-both": this.props.scrollable && "both" === this.props.scrollDirection,
          "datatable--scrollable-flex": this.props.scrollable && "flex" === this.props.scrollHeight,
          "datatable--responsive-stack": "stack" === this.props.responsiveLayout,
          "datatable--responsive-scroll": "scroll" === this.props.responsiveLayout,
          "datatable--has-striped-rows": this.props.stripedRows,
          "datatable--has-gridlines": this.props.showGridlines,
          "datatable--has-grouped-head": null !== this.props.headerColumnGroup,
          "datatable--has-grouped-foot": null !== this.props.footerColumnGroup,
          "datatable--small": "small" === this.props.size,
          "datatable--large": "large" === this.props.size
        }, this.props.className),
        d = this.renderHeader(),
        c = this.renderPaginatorTop(l),
        h = this.renderContent(o, n, a, i),
        m = this.renderPaginatorBottom(l),
        f = this.renderFooter(),
        g = this.renderResizeHelper(),
        S = this.renderReorderIndicators();
      return e.createElement("div", {
        ref: function ref(e) {
          return t.el = e;
        },
        id: this.props.id,
        className: u,
        style: this.props.style,
        "data-scrollselectors": ".datatable__wrapper"
      }, d, c, h, m, f, g, S);
    }
  }], v = [{
    key: "getDerivedStateFromProps",
    value: function value(e, t) {
      return e.rows === t.d_rows || e.onPage ? null : {
        rows: e.rows,
        d_rows: e.rows
      };
    }
  }], c && m(C.prototype, c), v && m(C, v), C;
}(t);
f(v, "defaultProps", {
  id: null,
  value: null,
  header: null,
  footer: null,
  style: null,
  className: null,
  tableStyle: null,
  tableClassName: null,
  paginator: !1,
  paginatorPosition: "bottom",
  alwaysShowPaginator: !0,
  paginatorClassName: null,
  paginatorLeft: null,
  paginatorRight: null,
  paginatorDropdownAppendTo: null,
  pageLinkSize: 5,
  rowsPerPageOptions: null,
  currentPageReportTemplate: d("pagination.showing"),
  first: 0,
  rows: null,
  totalRecords: null,
  lazy: !1,
  sortField: null,
  sortOrder: null,
  multiSortMeta: null,
  sortMode: "single",
  defaultSortOrder: 1,
  removableSort: !1,
  emptyMessage: null,
  selectionMode: null,
  dragSelection: !1,
  cellSelection: !1,
  selection: null,
  onSelectionChange: null,
  contextMenuSelection: null,
  onContextMenuSelectionChange: null,
  compareSelectionBy: "deepEquals",
  dataKey: null,
  metaKeySelection: !0,
  selectOnEdit: !0,
  headerColumnGroup: null,
  footerColumnGroup: null,
  rowExpansionTemplate: null,
  expandedRows: null,
  onRowToggle: null,
  resizableColumns: !1,
  columnResizeMode: "fit",
  reorderableColumns: !1,
  scrollable: !1,
  scrollHeight: null,
  scrollDirection: "vertical",
  virtualScrollerOptions: null,
  frozenWidth: null,
  frozenValue: null,
  csvSeparator: ",",
  exportFilename: "download",
  rowGroupMode: null,
  autoLayout: !1,
  rowClassName: null,
  cellClassName: null,
  rowGroupHeaderTemplate: null,
  rowGroupFooterTemplate: null,
  loading: !1,
  loadingIcon: "pi pi-spinner",
  tabIndex: 0,
  stateKey: null,
  stateStorage: "session",
  groupRowsBy: null,
  editMode: null,
  editingRows: null,
  expandableRowGroups: !1,
  rowHover: !1,
  showGridlines: !1,
  stripedRows: !1,
  size: "normal",
  responsiveLayout: "stack",
  breakpoint: "960px",
  expandedRowIcon: "pi pi-chevron-down",
  collapsedRowIcon: "pi pi-chevron-right",
  onRowEditComplete: null,
  showRowReorderElement: null,
  onColumnResizeEnd: null,
  onColumnResizerClick: null,
  onColumnResizerDoubleClick: null,
  onSort: null,
  onPage: null,
  onAllRowsSelect: null,
  onAllRowsUnselect: null,
  onRowClick: null,
  onRowDoubleClick: null,
  onRowSelect: null,
  onRowUnselect: null,
  onRowExpand: null,
  onRowCollapse: null,
  onContextMenu: null,
  onColReorder: null,
  onCellClick: null,
  onCellSelect: null,
  onCellUnselect: null,
  onRowReorder: null,
  onValueChange: null,
  rowEditValidator: null,
  onRowEditInit: null,
  onRowEditSave: null,
  onRowEditCancel: null,
  onRowEditChange: null,
  exportFunction: null,
  customSaveState: null,
  customRestoreState: null,
  onStateSave: null,
  onStateRestore: null,
  infiniteScrollOptions: null,
  canInfiniteScrollLoadMore: !1,
  onInfiniteScrollNextPage: null,
  infiniteScrollLoaderSize: 16,
  bulkActionsDropdownProps: null
});
export { v as DataTable };